/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SurveyCompanyEntitlementStatus {
    GRANTED = 'GRANTED',
    PENDING_VERIFICATION = 'PENDING_VERIFICATION',
    DENIED = 'DENIED',
}
